import React from 'react'

import { JOBS } from '../../../constants/jobs'

import redux from './redux'
import { DashboardView } from './view'

class DashboardContainer extends React.Component {
  state = {
    showMapView: true,
    sortBy: JOBS.SORTBY.PRIORITY.value,
  }

  componentDidMount() {
    this.props.dispatchFetchUserInfo()
    this.props.dispatchFetchJobs()
  }

  onSelectSortBy = (event) => {
    this.setState({ sortBy: event.target.value })
    this.props.dispatchFetchJobs(event.target.value)
  }

  onShowMapView = () => {
    this.setState({ showMapView: true })
  }

  onHideMapView = () => {
    this.setState({ showMapView: false })
  }

  render() {
    return (
      <DashboardView
        {...this.props}
        {...this.state}
        onShowMapView={this.onShowMapView}
        onHideMapView={this.onHideMapView}
        onSelectSortBy={this.onSelectSortBy}
      />
    )
  }
}
const Dashboard = redux(DashboardContainer)

export { Dashboard }
